<div class="noPrint" [ngClass]="isModal ? 'modal-content modal-md' : ''">
    <div class="modal-header justify-content-center" *ngIf="title && isModal">
        <h3>{{ title | cxTranslate }}</h3>
    </div>
    <div class="loader-container" #divSpinner role="status">
        <div class="loader">{{ 'spinner.loading' | cxTranslate }}</div>
    </div>
</div>
